/* eslint no-param-reassign: "error" */
import React, {
  useEffect,
} from 'react';

import {
  getStatus,
} from 'redux-resource';

import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  Flex,
} from 'web-styled';

import {
  Spinner,
  ManageVideos,
} from 'web-components';

import {
  coreActions,
} from '@gymcloud/core';

type Props = {
  resourceType: string,
  clientInfo: any,
};

const mapState = state => ({
  getVideosStatus: getStatus(
    state,
    [
      'videos.requests.fetchVideos.status',
    ],
  ),
});

const Videos = ({
  resourceType,
  clientInfo,
}: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      coreActions.requestPersonalVideos({
        userId: clientInfo.id,
        list: `${clientInfo.id}`,
      }),
    );
  }, [clientInfo.id, resourceType]);

  const { getVideosStatus } = useSelector(mapState, shallowEqual);

  return (
    <Flex
      fillSpace
      padding="15px"
    >
      {getVideosStatus.pending && (
        <Spinner message="Loading..." />
      )}

      {getVideosStatus.succeeded && (
        <ManageVideos
          videos={clientInfo.videos}
          itemWidth="191px"
          itemHeight="224px"
        />
      )}
    </Flex>
  );
};

export default Videos;
